// extracted by mini-css-extract-plugin
export var mt0 = "search-common-terms-module--mt-0--90385";
export var mt1 = "search-common-terms-module--mt-1--cfc7f";
export var mt2 = "search-common-terms-module--mt-2--3203e";
export var mt3 = "search-common-terms-module--mt-3--f3243";
export var mt4 = "search-common-terms-module--mt-4--52a75";
export var mt5 = "search-common-terms-module--mt-5--4ae89";
export var mt6 = "search-common-terms-module--mt-6--16ba9";
export var searchCommonTerms = "search-common-terms-module--search-common-terms--02444";
export var searchCommonTerms__header = "search-common-terms-module--search-common-terms__header--29839";
export var searchCommonTerms__item = "search-common-terms-module--search-common-terms__item--3c339";
export var searchCommonTerms__link = "search-common-terms-module--search-common-terms__link--ee666";
export var searchCommonTerms__list = "search-common-terms-module--search-common-terms__list--fb927";